import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../hooks/useAuth';

interface AuthMiddlewareProps {
  children: React.ReactNode;
}

export const AuthMiddleware: React.FC<AuthMiddlewareProps> = ({ children }) => {
  const { user, isInitialized } = useAuth();
  const location = useLocation();
  const isAuthenticated =
    user !== null &&
    Boolean(user?.access) &&
    Boolean(user?.refresh) &&
    user.access !== "undefined" &&
    user.refresh !== "undefined";
  const isPrivateRoute = location.pathname.startsWith('/home');
  const isPublicRoute = !isPrivateRoute;

  // Don't redirect while auth is initializing
  if (!isInitialized) {
    return <>{children}</>
  }

  // If user is not authenticated and trying to access private routes, redirect to sign in
  // Pass the current location as state so we can redirect back after authentication
  if (!isAuthenticated && isPrivateRoute) {
    return <Navigate to="/" state={{ from: location }} replace />;
  }

  // If user is authenticated and trying to access public routes, redirect to intended destination or default
  if (isAuthenticated && isPublicRoute) {
    // Check if there's a redirect destination from the login state
    const from = location.state?.from?.pathname || '/home/dashboard';
    return <Navigate to={from} replace />;
  }

  return <>{children}</>;
};
